import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import { Alert } from '../../utilities';
import { ChangeDetectorRef } from '@angular/core';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';

declare const $: any;

@Component({
    selector: 'app-question-multi-dropdown-perc',
    templateUrl: './question-multi-dropdown-perc.component.html',
    styleUrls: ['./question-multi-dropdown-perc.component.scss'],
    standalone: false
})
export class QuestionMultiDropdownPercComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() question: Question;
  @Input() showToolTip = false;
  @Input() showDelete = false;
  @Output() questionAnswer = new EventEmitter<any>();

  maskOptions: NgxCurrencyConfig;
  value = '';
  uniqueControlName = `label-percentage-${newGuid()}`;
  uniqueId = `label-percentage-${newGuid()}`;
  options: any;
  dataset: any = [
    {
      "answer": "",
      "percentage": 0
    }
  ];
  selectedAnswer ='';
  selectedPerc = 0;
  parameter: any;
  totaloptions = 1;
  totalperc = 100;
  addAnotherLabel = 'Add Another';

  constructor(private questionService: GlobalQuestionService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    console.log(this.question);
    if (this.question?.options) {
      //this.options = JSON.parse(this.question.options);
      this.options = JSON.parse(this.question.options).map((option: any) => ({
        ...option,
        disabled: false
      }));

    }
    console.log(this.options);
    setTimeout(() => {
      this.questionService.initPopoverCustomize();
    }, 500);
    this.maskOptions = {
      max: 100,
      min: 0,
      allowZero: true,
      nullable: false,
      align: 'right',
      allowNegative: false,
      prefix: '',
      decimal: '',
      suffix: '',
      thousands: '',
      precision: 0
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.value = '';
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answer) {
        this.dataset = JSON.parse(this.question?.answer);
      }
    }
    if (changes?.showToolTip?.currentValue) {
      this.showToolTip = changes?.showToolTip?.currentValue;
    }
    if (changes?.showDelete?.currentValue) {
      this.showDelete = changes?.showDelete?.currentValue;
    }

    try {
      this.parameter = JSON.parse(this.question.parameter);
      console.log(this.parameter);
      if (this.parameter && this.parameter.find(p => p.parameter === 'totaloptions') !== '') {
        this.totaloptions = +this.parameter.find(p => p.parameter === 'totaloptions')?.value;
      }
       if (this.parameter && this.parameter.find(p => p.parameter === 'totalperc') !== '') {
        this.totalperc = +this.parameter.find(p => p.parameter === 'totalperc')?.value;
      }
      if (this.parameter.find(p => p.parameter === 'addanotherlabel') !== ''){
        this.addAnotherLabel = this.parameter.find(p => p.parameter === 'addanotherlabel')?.value;
      };
    } catch (e) { }
    
  }

  onChange(): void {
    console.log(this.value, this.question)
   
  }
 
  trackByIndex(index: number, item: any): number {
    return index;
  }

  setData(event: any, index: number): void {
    const exists = this.dataset.some(ind => ind.answer === event);
    if (!exists) {
      this.dataset[index].answer = event;
    }else{
      this.dataset.splice(index, 1);

    }
    this.options.forEach((option: any) => {
      if (option.answer == event) {
        option.disabled = true;
      }
    });

    if (this.getTotalPercentage() === 100) {
      this.question.answer = JSON.stringify(this.dataset);
    } else {
      this.question.answer = null;
    }
    this.questionAnswer.emit(this.question);

    console.log(event, this.options);
  }

  setPercentage(event: Event, index: number): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    // You might want to add validation here to ensure the value is a number
    if (value)  {
      let percentageValue = parseFloat(value);
      if (index !== -1) {
        this.dataset[index].percentage = percentageValue;
      }
      
      this.dataset = this.dataset.filter(industry => industry.answer !== '');
    }
    if (this.getTotalPercentage() === 100){
      this.question.answer = JSON.stringify(this.dataset);
      this.questionAnswer.emit(this.question);
    }
    else {
      this.question.answer = null;
      this.questionAnswer.emit(this.question);
    }
    console.log(this.question);

  }
  addAnother(): void {
    if (this.dataset.length >= this.totaloptions) {
      Alert(`You can only add up to ${this.totaloptions} .`);
      return;
    }
    this.dataset.push({
      "answer": "",
      "percentage": 0,
    });

  }
  removeData(option: any, index: number): void {
    console.log(option);
    console.log(index);
    if (index !== -1) {
      this.dataset.splice(index, 1); // Remove 1 element at the found index
      if (this.getTotalPercentage() === 100) {
        this.question.answer = JSON.stringify(this.dataset);
        this.questionAnswer.emit(this.question);
      }
      else {
        this.question.answer = null;
        this.questionAnswer.emit(this.question);
      }
    }

     this.options.forEach((option: any) => {
      if (option.answer == option.answer) {
        option.disabled = false;
      }
    });
  }
  getTotalPercentage(): number {
  return this.dataset.reduce((sum, industry) => {
    const value = parseFloat(industry.percentage) || 0;
    return sum + value;
  }, 0);
}


}
